export const environment = {
  production: true,
  buildId: '2949119916819771',
  configFile: 'config.json',
};
